import React from "react";

const OTCard = ({ ot }) => {
  return (
    <div className="rounded-lg overflow-hidden shadow-lg transform hover:scale-105 transition duration-300">
      <div className="bg-gradient-to-r from-red-500 to-orange-500 p-4 flex items-center justify-between">
        <h4 className="text-lg font-bold text-white">{ot.otName}</h4>
      </div>
      <div className="p-4 bg-white">
        <p className="text-gray-600 text-sm">Category: {ot.category}</p>
        <button className="mt-4 w-full bg-orange-500 text-white py-2 rounded hover:bg-orange-600 transition duration-300">
          View Details
        </button>
      </div>
    </div>
  );
};

export default OTCard;
